import React, { Fragment, useState, useEffect } from 'react';
import Lang from '../../../components/language/services/Lang';
import HrbTranslate from '../../../components/language/HrbTranslate';
import VerticalNameValue from '../../../components/library/layout/VerticalNameValue';
import ProvinceText from '../../../components/library/common/ProvinceText';
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren';

const ClientAccountInformation = (props) => {
    const [loading, setLoading] = useState(true);
    const [languageKey, setLanguageKey] = useState(null);
    const [phoneValue, setPhoneValue] = useState(null)

    useEffect(() => {
        var lding = !props.client || (!props.client.userName && !props.client.email)
        setLoading(lding);
        if (!lding) {
            setLanguageKey(props.client.language ? `Account.Language.${props.client.language}` : null)
            if (props.client.phone) {
                if (props.client.phone.length === 7) {
                    setPhoneValue(props.client.phone.slice(0, 3) + '-' + props.client.phone.substring(3))
                } else if (props.client.phone.length === 10) {
                    setPhoneValue(props.client.phone.slice(0, 3) + '-' + props.client.phone.slice(3, 6) + '-' + props.client.phone.substring(6))
                } else {
                    setPhoneValue(props.client.phone === null ? '' : props.client.phone)
                }
            }
            else {
                setPhoneValue('')
            }
        }        
    }, [props.client])

    return (
        <Fragment>
            <div className='columns'>
                <div className='column is-1' />
                <div className='column is-10'>
                    <h4><HrbTranslate text='Account.Headers.AccountInfo' /></h4>
                </div>
                <div className='column is-1' />
            </div>
            <div className='columns'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey='Account.Labels.Username'
                        loading={loading}
                        value={props.client ? props.client.userName : null}
                    />
                </div>
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey='Account.Labels.Phone'
                        loading={loading}
                        value={phoneValue}
                    />
                </div>
                <div className='column is-2'>
                    <VerticalNameChildren
                        textKey='Account.Labels.ProvinceTerritory'
                        loading={loading}>
                        {!loading &&
                            <p className='p1 medium-weight'>
                                <ProvinceText province={props.client ? props.client.province : null} />
                            </p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-1' />
            </div>
            <div className='columns'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey='Account.Labels.Email'
                        loading={loading}
                        value={props.client ? props.client.email : null}
                    />
                </div>
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey='Account.Labels.RecoveryEmail'
                        loading={loading}
                        value={props.client ? props.client.recoveryEmail : null}
                    />
                </div>
                <div className='column is-2'>
                    <VerticalNameValue
                        textKey='Account.Labels.Language'
                        loading={loading}
                        value={languageKey ? Lang.getCurrentValue(languageKey) : null}
                    />
                </div>
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

ClientAccountInformation.whyDidYouRender = false;

export default ClientAccountInformation